// 按需导入 Vant 组件
import {
    Button,
    Cell,
    CellGroup,
    Icon,
    Image as VanImage,
    NoticeBar,
    Search,
    Checkbox,
    CheckboxGroup,
    Field,
    Form,
    ActionSheet,
    List,
    Sticky,
    BackTop,
    Tag,
    Collapse,
    CollapseItem,
    Step,
    Steps,
    DropdownMenu,
    DropdownItem,
    PickerGroup,
    Picker,
    Popup as VanPopup,
} from "vant";

import "vant/lib/index.css";

// 安装函数
const installVantComponents = (app) => {
    // 注册组件
    app.use(Button);
    app.use(Cell);
    app.use(CellGroup);
    app.use(Icon);
    app.use(VanImage);
    app.use(NoticeBar);
    app.use(Search);
    app.use(Checkbox);
    app.use(CheckboxGroup);
    app.use(Field);
    app.use(Form);
    app.use(ActionSheet);
    app.use(Sticky);
    app.use(List);
    app.use(BackTop);
    app.use(Tag);
    app.use(Collapse);
    app.use(CollapseItem);
    app.use(Step);
    app.use(Steps);
    app.use(DropdownMenu);
    app.use(DropdownItem);
    app.use(PickerGroup);
    app.use(Picker);
    app.use(VanPopup);
};

// 导出安装函数
export default installVantComponents;
